import { AfterViewInit, Component } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { MortgageApplicationService } from '../../../../form-application/mortgage-application/services/mortgage-application.service';
import { BaseMortgageApplicationComponent } from '../base-mortgage-application.component';
import { ReferenceDataConstants } from './../../../../lib/constants/reference-data-constants';
import { DeclarationPageContentDto } from './../../models/declaration-page-content-dto';
import { MortgageApplicationStore } from './../../services/mortgage-application-store';

@Component({
  selector: 'boi-declaration',
  templateUrl: './declaration.page.html',
  styleUrls: ['./declaration.page.scss']
})
export class DeclarationPage extends BaseMortgageApplicationComponent implements AfterViewInit {
  public declarationDto: DeclarationPageContentDto;
  referenceDataConstants = ReferenceDataConstants;

  constructor(
    protected mortgageApplicationStore: MortgageApplicationStore,
    private mortgageApplicationService: MortgageApplicationService
  ) {
    super(mortgageApplicationStore);
  }

  public ngAfterViewInit(): void {
    this.setDeclarationDto();
  }

  private setDeclarationDto(): void {
    this.mortgageApplicationService
      .getDeclarationPageContent(this.mortgageApplication)
      .pipe(takeUntil(this.destroySubject$))
      .subscribe((data) => {
        this.declarationDto = data;
      });
  }
}
